export function shippingAccountValidate(shipping_account){
    var result = true;

    result = validateId(shipping_account.id);
    result = validateName(shipping_account.name);
    
    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name){
    if(typeof name === 'string' && name.trim() !== '') return true;
    else return false;
}